module.exports = __webpack_public_path__ + "static/media/LSB (2).80a8a2c5.jpg";